import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var RefComponentsNamespaceErrorCode;
(function (RefComponentsNamespaceErrorCode) {
    RefComponentsNamespaceErrorCode["UnableToFindComponentBySelector"] = "UnableToFindComponentBySelector";
    RefComponentsNamespaceErrorCode["UnableToGetHiddenNoneRefComponents"] = "UnableToGetHiddenNoneRefComponents";
    RefComponentsNamespaceErrorCode["UnableToFindRefComponent"] = "UnableToFindRefComponent";
})(RefComponentsNamespaceErrorCode || (RefComponentsNamespaceErrorCode = {}));
class RefComponentsNamespaceError extends BaseError {
    constructor(message, code) {
        super(message, code, 'EP RefComponentsNamespace Error');
        this.state = {};
    }
    withComponentId(componentId) {
        this.state.componentId = componentId;
        return this;
    }
    withSelector(selector) {
        this.state.selector = selector;
        return this;
    }
    withRootComponentId(rootComponentId) {
        this.state.rootComponentId = rootComponentId;
        return this;
    }
}
export const createRefComponentsError = createErrorBuilder(RefComponentsNamespaceError);
//# sourceMappingURL=errors.js.map